import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import s from './Attribution.scss';
var Attribution = function (_a) {
    var author = _a.author, relatedItemBiData = _a.relatedItemBiData, className = _a.className, _b = _a.avatarSize, avatarSize = _b === void 0 ? 25 : _b, _c = _a.showAvatar, showAvatar = _c === void 0 ? true : _c, showAuthorTooltip = _a.showAuthorTooltip, _d = _a.showAuthorName, showAuthorName = _d === void 0 ? true : _d, userlinkClassName = _a.userlinkClassName;
    var t = useTranslation().t;
    return (React.createElement("div", { className: classnames(s['attribution'], !showAvatar && s['no-avatar'], className) }, author && (React.createElement(React.Fragment, null,
        showAvatar && (React.createElement(UserAvatar, { size: avatarSize, className: s['avatar'], user: author, withTooltip: showAuthorTooltip, relatedItemBiData: relatedItemBiData, "aria-label": author.username })),
        !showAvatar && React.createElement(React.Fragment, null,
            t('deviationview.overlay.by'),
            "\u00A0"),
        showAuthorName && (React.createElement(UserLink, { className: classnames(s['user-link'], userlinkClassName), user: author, withTooltip: showAuthorTooltip, biData: {
                creatorid: author.useridUuid,
            }, relatedItemBiData: relatedItemBiData }))))));
};
Attribution.displayName = 'Attribution';
export default Attribution;
//# sourceMappingURL=Attribution.js.map